<script>
    import Button from './Button.svelte';
    import Panel from './Panel.svelte';
    import party from 'party-js';
    import { logEvent } from './utils/logs';
    import { createEventDispatcher, onMount } from 'svelte';
    let className = '';
    export { className as class };

    export let form_name = 'emails';
    export let data = {};

    export let label_text =
        "Want us to notify you when we're taking off? Leave your email below:";
    export let cta_text = 'Join the mission';
    export let success_message =
        'Thank you and see you when the journey begins!';
    export let error_message = 'Something went wrong. Please try again.';
    export let narrow = false;

    let form_holder_element;
    const dispatch = createEventDispatcher();

    let has_success = false;
    let has_error = false;
    let is_loading = false;

    /**
     * @param {Event} event
     */
    const handleSubmit = (event) => {
        event.preventDefault();

        console.log('submitting form');

        has_success = false;
        has_error = false;
        is_loading = true;

        //@ts-ignore
        const myForm = event.target;

        if (!myForm) return;

        // @ts-ignore
        const formData = new FormData(myForm);

        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        }

        try {
            fetch('/api/email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                // @ts-ignore
                body: new URLSearchParams(formData).toString()
            })
                .then((res) => {
                    if (res.ok) {
                        has_success = true;
                        // party.confetti(form_holder_element, {
                        //     count: party.variation.range(50, 100)
                        // });

                        logEvent('email_signup', {
                            form_name
                        });

                        dispatch('success', {
                            form_name,
                            email: formData.get('email')
                        });
                    } else {
                        has_error = true;
                        logEvent('email_signup_error', {
                            form_name
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    has_error = true;
                    logEvent('email_signup_error', {
                        form_name
                    });
                })
                .finally(() => {
                    is_loading = false;
                });
        } catch (error) {
            console.error(error);
            has_error = true;
            is_loading = false;

            logEvent('email_signup_error', {
                form_name
            });
        }

        dispatch('submit', {
            email: formData.get('email'),
            form_name,
            ...data
        });
    };

    onMount(() => {
        logEvent('email_signup_view', {
            form_name,
            ...data
        });
    });
</script>

<div class="relative" bind:this={form_holder_element}>
    {#if has_success}
        <Panel success class="text-2xl text-center max-w-xl mx-auto">
            {success_message}
        </Panel>
    {:else}
        <form
            name={form_name}
            method="POST"
            class="flex flex-col gap-4 text-center {className} relative"
            on:submit={handleSubmit}
        >
            <input type="hidden" name="form-name" value={form_name} />

            {#if label_text}
                <label for="email" class="text-2xl my-2">{label_text}</label>
            {/if}

            {#if has_error}
                <Panel error>
                    {error_message}
                </Panel>
            {/if}

            <fieldset
                class="flex flex-nowrap gap-2 {narrow
                    ? 'flex-col'
                    : 'max-sm:flex-col '}"
            >
                <input type="text" name="username" class="hidden" />

                <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="something@something.com"
                    class="w-full p-4 rounded-md text-blue-950 text-lg"
                    required
                />
                <Button primary submit lg class="whitespace-nowrap" loading={is_loading} loading_spinner>
                    {cta_text}
                </Button>
            </fieldset>
        </form>
    {/if}
</div>
